import { find } from 'lodash'
import {
  STATUSES,
  TYPES,
  WIDTH_BY_TYPE,
  HEIGHT_BY_TYPE,
  HINTS_BY_TYPE,
  OPTIONS_BY_TYPE,
  FIELD_DEFAULT_POSITION_X,
  FIELD_DEFAULT_POSITION_Y,
  FIELD_DEFAULT_FONT_SIZE,
  FIELD_DEFAULT_HEIGHT
} from '~/modules/templates/constants/fields'

export const createPayload = (stateFields, type, overrides = {}) => {
  const isDefaultPlacedField = find(stateFields, field => field.positionY % 50 === 0)
  return {
    type: TYPES[type],
    key: TYPES[type] + '_' + Math.ceil(Math.random() * 1000), // todo: find better approach
    width: WIDTH_BY_TYPE[type],
    height: HEIGHT_BY_TYPE[type] ?? FIELD_DEFAULT_HEIGHT,
    positionX: FIELD_DEFAULT_POSITION_X,
    positionY: isDefaultPlacedField ? FIELD_DEFAULT_POSITION_Y * 2 : FIELD_DEFAULT_POSITION_Y,
    status: STATUSES.new,
    hint: HINTS_BY_TYPE[type] ?? null,
    textSize: FIELD_DEFAULT_FONT_SIZE,
    options: OPTIONS_BY_TYPE[type] ?? null,
    required: true,
    changed: false,
    ...overrides
  }
}
